import React from 'react'
import { Button } from '@material-ui/core'

// components
import PageTitle from '../../../components/PageTitle/PageTitle'

import WalletPage from '../wallet'

export default function FantomPage() {
    return (
        <>
            <WalletPage chainId={250} />
        </>
    )
}
